import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HiOutlineShieldCheck } from "react-icons/hi";
import ROUTES from "../../../config/routes";
import "./NafathPromptModal.css";
export default function NafathPromptModal({
  show,
  onHide
}) {
  useLanguage();
  const navigate = useNavigate();
  const handleVerifyNow = () => {
    onHide();
    navigate(ROUTES.NAFATH_VERIFICATION);
  };
  return <Modal show={show} onHide={onHide} centered className="bb-nafath-modal">
      <Modal.Body className="bb-nafath-modal__body">
        <div className="bb-nafath-modal__icon">
          <HiOutlineShieldCheck />
        </div>

        <h3 className="bb-nafath-modal__title">{t("Verification Required")}</h3>

        <p className="bb-nafath-modal__text">{t("To continue with this action, you need to complete your Nafath verification. This helps BaytBuddy maintain a more trusted and secure platform experience.")}



        </p>

        <div className="bb-nafath-modal__actions">
          <Button variant="outline-secondary" onClick={onHide}>{t("Cancel")}

          </Button>
          <Button onClick={handleVerifyNow}>{t("Verify Now")}</Button>
        </div>
      </Modal.Body>
    </Modal>;
}
